import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-100);
  padding: var(--space-200) var(--space-300);
  text-align: left;
  white-space: wrap;
  max-width: 252px;
`

export const Title = styled.div`
  color: var(--text-primary);
  font-family: var(--font-family-body);
  font-size: var(--font-size-400);
  font-style: normal;
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-400); /* 150% */
  letter-spacing: var(--font-letter-spacing-normal);
`

export const Description = styled.div`
  color: var(--text-secondary);
  font-family: var(--font-family-body);
  font-size: var(--font-size-300);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-300); /* 150% */
  letter-spacing: var(--font-letter-spacing-loose);
`

export const Formula = styled.div`
  color: var(--text-secondary);
  font-family: var(--font-family-mono);
  font-size: var(--font-size-200);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-200); /* 133.333% */
  letter-spacing: var(--font-letter-spacing-normal);
`
